import React, { createElement } from 'react'

const sprite = [
  {
    name: 'rename',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 8H4C2.89543 8 2 8.89543 2 10V14C2 15.1046 2.89543 16 4 16H10" stroke="currentColor" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18 16L20 16C21.1046 16 22 15.1046 22 14L22 10C22 8.89543 21.1046 8 20 8L18 8" stroke="currentColor" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10 21L11 21C12.6569 21 14 19.6569 14 18L14 6C14 4.34315 12.6569 3 11 3L10 3" stroke="currentColor" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18 21L17 21C15.3431 21 14 19.6569 14 18L14 6C14 4.34315 15.3431 3 17 3L18 3" stroke="currentColor" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'move',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 9L2 12L5 15" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 5L12 2L15 5" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15 19L12 22L9 19" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 9L22 12L19 15" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2 12H9" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15 12H22" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 2V22" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'edit',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V13" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.5 2.50023C19.8978 2.1024 20.4374 2 21 2C21.5626 2 22.1022 2.1024 22.5 2.50023C22.8978 2.89805 23 3.43762 23 4.00023C23 4.56284 22.8978 5.1024 22.5 5.50023L13 15.0002L9 16.0002L10 12.0002L19.5 2.50023Z" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'delete',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 6L5.8242 19.1871C5.92301 20.7682 7.23416 22 8.81835 22H15.1816C16.7658 22 18.077 20.7682 18.1758 19.1871L19 6" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3 6H5H21" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 11V17" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 11V17" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'share',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 14V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V14" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21 17L21 9C21 8.46957 20.7893 7.96086 20.4142 7.58579C20.0391 7.21071 19.5304 7 19 7L17 7M3 17L3 9C3 8.46957 3.21071 7.96086 3.58579 7.58579C3.96086 7.21071 4.46957 7 5 7L7 7" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15 4L12 1L9 4" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 1V14" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'restore',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 7L4 7C3.44772 7 3 6.55228 3 6L3 2" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C8.7288 2 5.82446 3.57069 4 5.99902" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.6558 17.1C11.5825 17.1 11.5202 17.0743 11.4688 17.023C11.4175 16.9717 11.3918 16.9093 11.3918 16.836V16.066C10.8492 16.0147 10.3908 15.8863 10.0168 15.681C9.64282 15.4683 9.36049 15.2153 9.16982 14.922C8.97915 14.6213 8.87649 14.3097 8.86182 13.987C8.86182 13.921 8.88382 13.866 8.92782 13.822C8.97915 13.778 9.03782 13.756 9.10382 13.756H10.0828C10.1708 13.756 10.2405 13.778 10.2918 13.822C10.3432 13.8587 10.3835 13.9063 10.4128 13.965C10.4642 14.1043 10.5485 14.2437 10.6658 14.383C10.7905 14.515 10.9628 14.625 11.1828 14.713C11.4028 14.801 11.6778 14.845 12.0078 14.845C12.5358 14.845 12.9282 14.757 13.1848 14.581C13.4415 14.405 13.5698 14.1667 13.5698 13.866C13.5698 13.6533 13.5002 13.4847 13.3608 13.36C13.2288 13.228 13.0162 13.1107 12.7228 13.008C12.4295 12.898 12.0445 12.7843 11.5678 12.667C11.0252 12.535 10.5668 12.3773 10.1928 12.194C9.81882 12.0033 9.53649 11.765 9.34582 11.479C9.16249 11.193 9.07082 10.83 9.07082 10.39C9.07082 9.82533 9.27615 9.345 9.68682 8.949C10.0975 8.553 10.6658 8.311 11.3918 8.223V7.464C11.3918 7.39067 11.4175 7.32833 11.4688 7.277C11.5202 7.22567 11.5825 7.2 11.6558 7.2H12.3268C12.4002 7.2 12.4625 7.22567 12.5138 7.277C12.5652 7.32833 12.5908 7.39067 12.5908 7.464V8.245C13.0895 8.31833 13.5075 8.465 13.8448 8.685C14.1822 8.905 14.4388 9.158 14.6148 9.444C14.7908 9.72267 14.8825 9.994 14.8898 10.258C14.8898 10.3167 14.8678 10.3717 14.8238 10.423C14.7872 10.467 14.7322 10.489 14.6588 10.489H13.6358C13.5698 10.489 13.5075 10.4743 13.4488 10.445C13.3902 10.4157 13.3425 10.3607 13.3058 10.28C13.2692 10.0527 13.1298 9.85833 12.8878 9.697C12.6458 9.53567 12.3305 9.455 11.9418 9.455C11.5458 9.455 11.2268 9.52833 10.9848 9.675C10.7502 9.82167 10.6328 10.049 10.6328 10.357C10.6328 10.5623 10.6915 10.7347 10.8088 10.874C10.9262 11.006 11.1168 11.1233 11.3808 11.226C11.6522 11.3287 12.0115 11.4387 12.4588 11.556C13.0822 11.6953 13.5882 11.8567 13.9768 12.04C14.3728 12.2233 14.6625 12.458 14.8458 12.744C15.0365 13.0227 15.1318 13.3783 15.1318 13.811C15.1318 14.2363 15.0255 14.6103 14.8128 14.933C14.6075 15.2483 14.3142 15.505 13.9328 15.703C13.5515 15.8937 13.1042 16.0183 12.5908 16.077V16.836C12.5908 16.9093 12.5652 16.9717 12.5138 17.023C12.4625 17.0743 12.4002 17.1 12.3268 17.1H11.6558Z" fill="currentColor"/>
      </svg>
    `,
  },
  {
    name: 'privacy',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 11L11.25 14L15 8" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'file',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 2H13L20 9V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2Z" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13 2V9H20" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'message',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 12H12" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 8H16" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'angle-left',
    svg: `
      <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3L3 12L12 21" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    `,
  },
  {
    name: 'angle-right',
    svg: `
      <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6L12 12L6 18" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'premium',
    className: 'svg-icon-premium',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 16.4009V7.5991C21.9996 7.21322 21.8967 6.83423 21.7017 6.50015C21.5067 6.16607 21.2264 5.88865 20.8889 5.69571L13.1111 1.2948C12.7733 1.10167 12.3901 1 12 1C11.6099 1 11.2267 1.10167 10.8889 1.2948L3.11111 5.69571C2.77363 5.88865 2.49331 6.16607 2.29829 6.50015C2.10327 6.83423 2.0004 7.21322 2 7.5991V16.4009C2.0004 16.7868 2.10327 17.1658 2.29829 17.4998C2.49331 17.8339 2.77363 18.1114 3.11111 18.3043L10.8889 22.7052C11.2267 22.8983 11.6099 23 12 23C12.3901 23 12.7733 22.8983 13.1111 22.7052L20.8889 18.3043C21.2264 18.1114 21.5067 17.8339 21.7017 17.4998C21.8967 17.1658 21.9996 16.7868 22 16.4009Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M17.7396 10.985C17.9758 10.7648 18.0592 10.4415 17.9573 10.141C17.8552 9.84055 17.5892 9.62605 17.2624 9.58053L14.3568 9.17659C14.2331 9.15934 14.1262 9.08509 14.0709 8.97772L12.7719 6.45889C12.6261 6.17588 12.33 6 12.0001 6C11.6704 6 11.3744 6.17588 11.2286 6.45889L9.92934 8.97795C9.87407 9.08532 9.76691 9.15957 9.64316 9.17682L6.73763 9.58076C6.41108 9.62605 6.14484 9.84078 6.04272 10.1413C5.94084 10.4418 6.02422 10.765 6.26042 10.9852L8.36268 12.9459C8.4523 13.0296 8.49339 13.15 8.47225 13.2677L7.9763 16.0362C7.93233 16.2799 7.99913 16.517 8.16396 16.7039C8.42011 16.9952 8.86728 17.0839 9.22482 16.9041L11.8233 15.5969C11.9319 15.5424 12.0686 15.5429 12.177 15.5969L14.7757 16.9041C14.902 16.9678 15.0368 17 15.176 17C15.43 17 15.6707 16.8919 15.8363 16.7039C16.0014 16.517 16.0679 16.2795 16.0239 16.0362L15.5278 13.2677C15.5066 13.1498 15.5477 13.0296 15.6373 12.9459L17.7396 10.985Z" fill="white"/>
      </svg>
    `,
  },
  {
    name: 'burger',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 6L22 6" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" />
        <path d="M2 12L22 12" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" />
        <path d="M2 18L17 18" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    `,
  },
  {
    name: 'search',
    svg: `
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M20.9999 20.9999L16.6499 16.6499" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'sort-asc',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1879_51)">
          <path d="M17 4L17 20" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20 17L17 20L14 17" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.39 8.87C10.45 8.99667 10.48 9.12 10.48 9.24C10.48 9.46 10.39 9.64667 10.21 9.8C10.0367 9.95333 9.83667 10.03 9.61 10.03C9.45667 10.03 9.31667 9.99 9.19 9.91C9.06333 9.83 8.96333 9.71 8.89 9.55L8.44 8.54H5.2L4.74 9.55C4.66667 9.71 4.56333 9.83 4.43 9.91C4.30333 9.99 4.16333 10.03 4.01 10.03C3.78333 10.03 3.57667 9.95333 3.39 9.8C3.21 9.64667 3.12 9.46 3.12 9.24C3.12 9.12 3.15 8.99667 3.21 8.87L5.85 3.45C5.93667 3.27 6.06333 3.13333 6.23 3.04C6.40333 2.94 6.59333 2.89 6.8 2.89C7 2.89 7.18667 2.94 7.36 3.04C7.53333 3.13333 7.66333 3.27 7.75 3.45L10.39 8.87ZM5.82 7.16H7.82L6.82 4.93L5.82 7.16Z" fill="#20263E"/>
          <path d="M8.64 19.56C8.93333 19.56 9.15 19.6167 9.29 19.73C9.43667 19.8433 9.51 20.0233 9.51 20.27C9.51 20.5233 9.44 20.71 9.3 20.83C9.16 20.9433 8.94 21 8.64 21H4.64C4.39333 21 4.19667 20.9267 4.05 20.78C3.91 20.6333 3.84 20.45 3.84 20.23C3.84 20.01 3.91667 19.7933 4.07 19.58L7.15 15.39H4.73C4.43 15.39 4.20667 15.3333 4.06 15.22C3.92 15.1 3.85 14.92 3.85 14.68C3.85 14.4267 3.92 14.2433 4.06 14.13C4.20667 14.01 4.43 13.95 4.73 13.95H8.57C8.81 13.95 9 14.0233 9.14 14.17C9.28667 14.31 9.36 14.49 9.36 14.71C9.36 14.9367 9.28333 15.1567 9.13 15.37L6.05 19.56H8.64Z" fill="#20263E"/>
        </g>
        <defs>
        <clipPath id="clip0_1879_51">
            <rect width="24" height="24" fill="white"/>
        </clipPath>
        </defs>
      </svg>
    `,
  },
  {
    name: 'sort-desc',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1879_50)">
          <path d="M17 20L17 4" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 7L17 4L20 7" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.39 8.87C10.45 8.99667 10.48 9.12 10.48 9.24C10.48 9.46 10.39 9.64667 10.21 9.8C10.0367 9.95333 9.83667 10.03 9.61 10.03C9.45667 10.03 9.31667 9.99 9.19 9.91C9.06333 9.83 8.96333 9.71 8.89 9.55L8.44 8.54H5.2L4.74 9.55C4.66667 9.71 4.56333 9.83 4.43 9.91C4.30333 9.99 4.16333 10.03 4.01 10.03C3.78333 10.03 3.57667 9.95333 3.39 9.8C3.21 9.64667 3.12 9.46 3.12 9.24C3.12 9.12 3.15 8.99667 3.21 8.87L5.85 3.45C5.93667 3.27 6.06333 3.13333 6.23 3.04C6.40333 2.94 6.59333 2.89 6.8 2.89C7 2.89 7.18667 2.94 7.36 3.04C7.53333 3.13333 7.66333 3.27 7.75 3.45L10.39 8.87ZM5.82 7.16H7.82L6.82 4.93L5.82 7.16Z" fill="#20263E"/>
          <path d="M8.64 19.56C8.93333 19.56 9.15 19.6167 9.29 19.73C9.43667 19.8433 9.51 20.0233 9.51 20.27C9.51 20.5233 9.44 20.71 9.3 20.83C9.16 20.9433 8.94 21 8.64 21H4.64C4.39333 21 4.19667 20.9267 4.05 20.78C3.91 20.6333 3.84 20.45 3.84 20.23C3.84 20.01 3.91667 19.7933 4.07 19.58L7.15 15.39H4.73C4.43 15.39 4.20667 15.3333 4.06 15.22C3.92 15.1 3.85 14.92 3.85 14.68C3.85 14.4267 3.92 14.2433 4.06 14.13C4.20667 14.01 4.43 13.95 4.73 13.95H8.57C8.81 13.95 9 14.0233 9.14 14.17C9.28667 14.31 9.36 14.49 9.36 14.71C9.36 14.9367 9.28333 15.1567 9.13 15.37L6.05 19.56H8.64Z" fill="#20263E"/>
        </g>
        <defs>
        <clipPath id="clip0_1879_50">
            <rect width="24" height="24" fill="white"/>
        </clipPath>
        </defs>
      </svg>
    `,
  },
  {
    name: 'view-list',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 3H5C3.89543 3 3 3.89543 3 5V8C3 9.10457 3.89543 10 5 10H8C9.10457 10 10 9.10457 10 8V5C10 3.89543 9.10457 3 8 3Z" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 6.5H21" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 14H5C3.89543 14 3 14.8954 3 16V19C3 20.1046 3.89543 21 5 21H8C9.10457 21 10 20.1046 10 19V16C10 14.8954 9.10457 14 8 14Z" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 17.5H21" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'view-grid',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 3H5C3.89543 3 3 3.89543 3 5V8C3 9.10457 3.89543 10 5 10H8C9.10457 10 10 9.10457 10 8V5C10 3.89543 9.10457 3 8 3Z" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 3H16C14.8954 3 14 3.89543 14 5V8C14 9.10457 14.8954 10 16 10H19C20.1046 10 21 9.10457 21 8V5C21 3.89543 20.1046 3 19 3Z" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 14H16C14.8954 14 14 14.8954 14 16V19C14 20.1046 14.8954 21 16 21H19C20.1046 21 21 20.1046 21 19V16C21 14.8954 20.1046 14 19 14Z" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 14H5C3.89543 14 3 14.8954 3 16V19C3 20.1046 3.89543 21 5 21H8C9.10457 21 10 20.1046 10 19V16C10 14.8954 9.10457 14 8 14Z" stroke="#20263E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'plus',
    svg: `
      <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C12 0.447715 11.5523 0 11 0C10.4477 0 10 0.447715 10 1V10H1C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12H10V21C10 21.5523 10.4477 22 11 22C11.5523 22 12 21.5523 12 21V12H21C21.5523 12 22 11.5523 22 11C22 10.4477 21.5523 10 21 10H12V1Z" fill="currentColor"/>
      </svg>
    `,
  },
  {
    name: 'scan',
    svg: `
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2952_610)">
          <path d="M9.4814 1.3335H4.59251C3.7281 1.3335 2.8991 1.67688 2.28787 2.28811C1.67664 2.89934 1.33325 3.72835 1.33325 4.59276V9.48164M30.6666 9.48164V4.59276C30.6666 3.72835 30.3232 2.89934 29.712 2.28811C29.1007 1.67688 28.2717 1.3335 27.4073 1.3335H22.5184M22.5184 30.6668H27.4073C28.2717 30.6668 29.1007 30.3234 29.712 29.7122C30.3232 29.101 30.6666 28.272 30.6666 27.4076V22.5187M1.33325 22.5187V27.4076C1.33325 28.272 1.67664 29.101 2.28787 29.7122C2.8991 30.3234 3.7281 30.6668 4.59251 30.6668H9.4814" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16.8333 7.6665H10.9999C10.5579 7.6665 10.134 7.8421 9.82141 8.15466C9.50885 8.46722 9.33325 8.89114 9.33325 9.33317V22.6665C9.33325 23.1085 9.50885 23.5325 9.82141 23.845C10.134 24.1576 10.5579 24.3332 10.9999 24.3332H20.9999C21.4419 24.3332 21.8659 24.1576 22.1784 23.845C22.491 23.5325 22.6666 23.1085 22.6666 22.6665V13.4998L16.8333 7.6665Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16.8333 7.6665V13.4998H22.6666" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_2952_610">
            <rect width="32" height="32" fill="white"/>
        </clipPath>
        </defs>
      </svg>
    `,
  },
  {
    name: 'close',
    svg: `
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M26 6L6 26" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 6L26 26" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  {
    name: 'dots-v',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6" cy="12" r="1.5" fill="#20263E" />
        <circle cx="12" cy="12" r="1.5" fill="#20263E" />
        <circle cx="18" cy="12" r="1.5" fill="#20263E" />
      </svg>
    `,
  },
  {
    name: 'choice',
    svg: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 12L11 16L16 8" stroke="#02AAFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
]

function SvgSprite() {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'none' }}
    >
      {sprite.map((item) => (
        <symbol
          id={item.name}
          dangerouslySetInnerHTML={{ __html: item.svg }}
          key={item.name}
        />
      ))}
    </svg>
  )
}

export default SvgSprite
